import logger from 'redux-logger'
import { parseUrlParameters } from '../utils/utils'
import createSagaMiddleware from 'redux-saga'
import { applyMiddleware, createStore } from 'redux'
import rootReducer from '../reducers'
import thunkMiddleware from 'redux-thunk'
import kIndexSaga from '../sagas'

const useLogger = process.env.NODE_ENV === 'development'
const conditionalMiddleWare = useLogger ? [logger] : []
const urlParams = parseUrlParameters()
const initialPeriod = (urlParams.t && parseInt(urlParams.t.toString(), 10)) || 6
const initialMagnetometer = urlParams.mag || 'nur'
const sagaMiddleware = createSagaMiddleware()

export const getStore = () => {
  const store = createStore(
    rootReducer,
    {
      period: initialPeriod,
      selectedMagnetometer: initialMagnetometer,
    } as any, // ToDo: This is wrong
    applyMiddleware(...conditionalMiddleWare, thunkMiddleware, sagaMiddleware)
  )

  sagaMiddleware.run(kIndexSaga)

  return store
}
